import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { StoreProvider } from './lib/store'
import { MeshBackground } from './components/MeshBackground'
import { App } from './App'
import './theme/global.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MeshBackground />
    <BrowserRouter>
      <StoreProvider>
        <App />
      </StoreProvider>
    </BrowserRouter>
  </StrictMode>,
)
